import { render, staticRenderFns } from "./app_user_bankcard_bind.vue?vue&type=template&id=64a9a3ae&scoped=true&"
import script from "./app_user_bankcard_bind.vue?vue&type=script&lang=js&"
export * from "./app_user_bankcard_bind.vue?vue&type=script&lang=js&"
import style0 from "./app_user_bankcard_bind.vue?vue&type=style&index=0&id=64a9a3ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a9a3ae",
  null
  
)

export default component.exports